"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE = exports.DISPLAY = exports.DISPLAY_FONT_WEIGHT = exports.DISPLAY_FONT = exports.TEXT = exports.TEXT_FONT_WEIGHT = exports.TEXT_FONT = exports.FALLBACK_FONT = exports.FONT_RATIO = exports.BASELINE = exports.RHYTHM = exports.FONT_WEIGHT_BLACK = exports.FONT_WEIGHT_BOLD = exports.FONT_WEIGHT_SEMIBOLD = exports.FONT_WEIGHT_MEDIUM = exports.FONT_WEIGHT_REGULAR = exports.FONT_WEIGHT_THIN = exports.REM_UNIT = void 0;
var tslib_1 = require("tslib");
var scale_1 = require("../scale");
exports.REM_UNIT = 16;
exports.FONT_WEIGHT_THIN = 100;
exports.FONT_WEIGHT_REGULAR = 400;
exports.FONT_WEIGHT_MEDIUM = 500;
exports.FONT_WEIGHT_SEMIBOLD = 600;
exports.FONT_WEIGHT_BOLD = 700;
exports.FONT_WEIGHT_BLACK = 800;
exports.RHYTHM = scale_1.STEP / 2;
exports.BASELINE = scale_1.STEP * 2;
exports.FONT_RATIO = 0.6;
exports.FALLBACK_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
exports.TEXT_FONT = 'Inter';
exports.TEXT_FONT_WEIGHT = {
    REGULAR: exports.FONT_WEIGHT_REGULAR,
    MEDIUM: exports.FONT_WEIGHT_MEDIUM,
    BOLD: exports.FONT_WEIGHT_SEMIBOLD,
    BLACK: exports.FONT_WEIGHT_BLACK,
};
exports.TEXT = tslib_1.__assign({ FONT: "".concat(exports.TEXT_FONT, ", ").concat(exports.FALLBACK_FONT) }, exports.TEXT_FONT_WEIGHT);
exports.DISPLAY_FONT = 'Larsseit';
exports.DISPLAY_FONT_WEIGHT = {
    REGULAR: exports.FONT_WEIGHT_MEDIUM,
    BOLD: exports.FONT_WEIGHT_SEMIBOLD,
};
exports.DISPLAY = tslib_1.__assign({ FONT: "".concat(exports.DISPLAY_FONT, ", ").concat(exports.FALLBACK_FONT) }, exports.DISPLAY_FONT_WEIGHT);
exports.SCALE = [8, 10, 12, 14, 16, 18, 24, 32, 40, 48, 56];
//# sourceMappingURL=index.js.map